export default __webpack_public_path__ + "static/media/unfinishedTasksReminder.af5bf73b.gif";